import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import SecureDataflowService from "@/services/secureDataflowService";
import { ChannelDataUtil } from "@/utils/secure-dataflow"
import _ from "lodash";
import moment from "moment"
import Vue from "vue"
import { db } from "@/firebase/firebaseConfig.js";

const epVesselSdfChannel = AiseaApiFactory.get("enterpriseVesselSecureDataflowChannel");

export default {

  /**
   * チャンネルデータのキャッシュクリア.
   */
  async clearLocalDbChannelData() {
    await SecureDataflowService.clearChannelData();
  },

  /**
   * LiveモードとDateモード変更時の処理.
   */
  async setModeState({ commit, dispatch }, data) {

    if (data === "live") {
      await dispatch("getChannelMaster").catch(error => {
        return Promise.reject(error)
      });
      dispatch("subscribeChannelDataEngine");
    } else {
      dispatch("unsubscribeFirestore");
      dispatch("unsubscribeFirestoreForChart");      
    }
    commit("SET_MODE", data);
  },

  async setOriginIdState({ commit }) {
    const vessel = await SecureDataflowService.getVessel()
    let data = {
      engineOriginId: vessel.engine_origin_id,
      maneuveringOriginId: vessel.maneuvering_origin_id,
    }
    commit("SET_ORIGIN_ID", data)
  },

  async resetAlertSummaryLiveDatas({ commit }) {
    commit("RESET_ALERT_SUMMARY_LIVE_DATAS");
  },
  async resetEventSummaryLiveDatas({ commit }) {
    commit("RESET_EVENT_SUMMARY_LIVE_DATAS");
  },


  /**
   * 各kindの現在時刻のversionを取得してstateに保存
   */
   async setLatestVersion({state, dispatch}) {
    const vessel = await SecureDataflowService.getVessel();
    let datetime = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z"

    let promiseAll = [];

    // VersionState３種
    promiseAll.push(new Promise( async ( resolve ) => {   
      let payload =
        {
          vessel_id: vessel.vessel_info.id,
          params : {
            origin: state.kind["engine"].originId,
            kind: "engine",
            datetime: datetime,
          }
        }
      resolve(dispatch("setVersionState", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = 
        {
          vessel_id: vessel.vessel_info.id,
          params : {
            origin: state.kind["handling"].originId,
            kind: "handling",
            datetime: datetime,
          }
        }
        resolve(dispatch("setVersionState", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = 
        {
          vessel_id: vessel.vessel_info.id,
          params : {
            origin: state.kind["aisea_alert"].originId,
            kind: "aisea_alert",
            datetime: datetime,
          }
        }
        resolve(dispatch("setVersionState", payload));
    }));
    await Promise.all(promiseAll);
  },


  /**
   * 全てのチャンネルマスターデータを取得してstateに保存
   * 
   * modeによって時間を判定する live: liveモード初期化時に実行 date: データ取得が押されたときに実行
   */
  async getChannelMaster({state, dispatch}) {
    const vessel = await SecureDataflowService.getVessel();
    let datetime = ( state.mode === "live" ) ? 
      moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z" :
      state.channelTimeFrom;

    let promiseAll = [];

    // VersionState３種
    promiseAll.push(new Promise( async ( resolve ) => {   
      let payload =
        {
          vessel_id: vessel.vessel_info.id,
          params : {
            origin: state.kind["engine"].originId,
            kind: "engine",
            datetime: datetime,
          }
        }
      resolve(dispatch("setVersionState", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = 
        {
          vessel_id: vessel.vessel_info.id,
          params : {
            origin: state.kind["handling"].originId,
            kind: "handling",
            datetime: datetime,
          }
        }
        resolve(dispatch("setVersionState", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = 
        {
          vessel_id: vessel.vessel_info.id,
          params : {
            origin: state.kind["aisea_alert"].originId,
            kind: "aisea_alert",
            datetime: datetime,
          }
        }
        resolve(dispatch("setVersionState", payload));
    }));
    await Promise.all(promiseAll).catch((error) => {
      return Promise.reject(error)
    });


    let versionObject = state.kind;

    // 取得したkindを使って groupChannel２種, kindChannel３種を取得
    promiseAll = [];
    promiseAll.push(new Promise( async ( resolve ) => {       
        let payload = {
        vessel_id: vessel.vessel_info.id,
        kind: "engine",
        targetChannelGroup: null,
        params: {
          version_id: versionObject["engine"].versionId,
        }
      };
      resolve(dispatch("getChannelGroupChannelsState", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = {
        vessel_id: vessel.vessel_info.id,
        targetChannelGroup: "maneuvering",
        kind: "handling",
        params: {
          version_id: versionObject["handling"].versionId,
        }
      };
      resolve(dispatch("getChannelGroupChannelsState", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = {
        vessel_id: vessel.vessel_info.id,
        kind: "engine",
        params: {
          version_id: versionObject["engine"].versionId,
        }
      };
      resolve(dispatch("setKindChannelMaster", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = {
        vessel_id: vessel.vessel_info.id,
        kind: "handling",
        params: {
          version_id: versionObject["handling"].versionId,
        }
      };
      resolve(dispatch("setKindChannelMaster", payload));
    }));
    promiseAll.push(new Promise( async ( resolve ) => { 
      let payload = {
        vessel_id: vessel.vessel_info.id,
        kind: "aisea_alert",
        params: {
          version_id: versionObject["aisea_alert"].versionId,
        }
      };
      resolve(dispatch("setKindChannelMaster", payload));
    }));
    await Promise.all(promiseAll).catch((error) => {
      return Promise.reject(error)
    });
    return versionObject;
  },


  async setVersionState({ commit }, payload) {
    let res = await epVesselSdfChannel.getChannelVersions(payload.vessel_id, payload.params).catch((error) => {
      return Promise.reject(error)
    });
    commit("SET_VERSION_ID", {kind: payload.params.kind, version_id: res.data.version_id, version_name: res.data.version_name})
  },


  async getChannelGroupChannelsState({ commit }, payload) {
    let res = await epVesselSdfChannel.getChannels(payload.vessel_id, payload.params)
    res.data.channels.forEach(e =>  {
      let channelGroup = ""
      let channelGroupWildCard = ""
      if (!payload.targetChannelGroup) {
        // targetChannelGroupが指定されていなければ取得したデータのカテゴリからChannelGroupを割り出す
        for (let i = 3; i >= 1; i--) {
          if (e['category'+ i + "_id"]) {
            let layer = i
            let id = e['category'+ i + "_id"] ? e['category'+ i + "_id"] : "0"
            let num = e['category'+ i + "_number"] ? e['category'+ i + "_number"] : "0"
            channelGroup = layer + "/" + id + "/" + num
            channelGroupWildCard = layer + "/" + id + "/" + "0"
            break
          }
        }
      } else {
        // targetChannelGroupが指定されていれば指定したchannelGroupに格納
        channelGroup = payload.targetChannelGroup
      }
      let obj = {
        kind: payload.kind,
        targetChannelGroup: channelGroup, // どのデータ種別に対してチャンネルデータを入れるか指定
        channel: e
      }
      commit("SET_CHANNEL_GROUP_CHANNELS", obj)
      if (channelGroup != channelGroupWildCard) {
        obj = {
          kind: payload.kind,
          targetChannelGroup: channelGroupWildCard, // category_numberが0(*)のchannelGroupに対してもチャンネルデータを入れる
          channel: e
        }
        commit("SET_CHANNEL_GROUP_CHANNELS", obj)
      }
    })
  },


  async setKindChannelMaster({ commit }, payload) {
    let res = await epVesselSdfChannel.getChannels(payload.vessel_id, payload.params)
    let channelMasterObject = {}
    res.data.channels.forEach(e => {
      channelMasterObject[e.channel_id] = {
        channel_name: e.channel_name,
        value_string_options: e.value_string_options,
        value_number_range: e.value_number_range,
        unit: e.unit,
        kind: payload.kind,
      }
    })
    let obj = {
      kind: payload.kind, // どのデータ種別に対してチャンネルデータを入れるか指定
      channelMaster: channelMasterObject
    }
    commit("SET_CHANNEL_MASTER", obj)
  },

  async initializeCustomChannelIds({ commit }) {
    let ids = await SecureDataflowService.getCustomChannel();
    commit("SET_CUSTOM_CHANNEL_IDS", ids);
    return ids;
  },

  async setSelectedCategoryState({ commit }, data) {
    commit("SET_SELECTED_CATEGORY", data);
  },










  async setChannelTimeFromState({ commit }, data) {
    commit("SET_CHANNEL_TIME_FROM", data)
  },
  async setChannelTimeToState({ commit }, data) {
    commit("SET_CHANNEL_TIME_TO", data)
  },


  /**
   * アラート、もしくはイベントをステータスに指定してチャンネルデータを検索、stateに保存.
   * 
   */
   async setChannelsDataSearchedByStatus({ state, commit }, payload) {
    const vessel = await SecureDataflowService.getVessel();

    let channelTimeFromValueOf = moment(state.channelTimeFrom).valueOf();
    const channelTimeToValueOf = moment(state.channelTimeTo).valueOf();
    let channelTimeToBlockValueOf = null;

    // 単位時間(blockHours)ごとに分割してAPIから並列取得.
    const blockHours = 3;
    let promiseAll = [];
    while ( channelTimeFromValueOf < channelTimeToValueOf ) {
      channelTimeToBlockValueOf = Math.min( moment(channelTimeFromValueOf).add(blockHours, 'hours').valueOf(), channelTimeToValueOf );

      let promiseJob = new Promise( async(resolve) => {

        let params = {
          vessel_id: vessel.vessel_info.id,
          body: {
            channel_time_from: moment(channelTimeFromValueOf).toISOString(),
            channel_time_to: moment(channelTimeToBlockValueOf).toISOString(),
            status_contains: payload.status_contains,
            channel_ids: payload.channel_ids,
          }
        };

        const startTime = moment().valueOf();          
        let res = await epVesselSdfChannel.searchChannelsDataByStatus(params.vessel_id, params.body);
        Vue.$log.debug("searchChannelsDataByStatus API", ( moment().valueOf() - startTime ) + 'ms', params.body);          

        let filtered_data = res.data.data
        .filter(channel_data => state.channelMaster[channel_data.kind][channel_data.channel_id])
        .map((channel_data) => {
          return {
            channel_time: channel_data.channel_time,
            channel_id: channel_data.channel_id,
            channel_name: state.channelMaster[channel_data.kind][channel_data.channel_id].channel_name,
            value_string_options: state.channelMaster[channel_data.kind][channel_data.channel_id].value_string_options,
            value_string: channel_data.value_string,
            value_number: channel_data.value_number,
            unit: state.channelMaster[channel_data.kind][channel_data.channel_id].unit,
            status: channel_data.status,
            kind: channel_data.kind,
          }
        });

        let obj = {
          targetChannelGroup: payload.channel_group, // どのデータ種別に対してチャンネルデータを入れるか指定
          channel: filtered_data,
        };
        resolve(obj);

      }); 
      promiseAll.push(promiseJob);

      channelTimeFromValueOf = channelTimeToBlockValueOf;
    }


    const statusDataList = await Promise.all(promiseAll);
    let  statusDataWholeList = [];
    statusDataList.forEach(statusData => {
      statusDataWholeList = statusDataWholeList.concat(statusData.channel);
    });
    statusDataWholeList.forEach((x, index)=> { x.id = index; }); // recycle-scroller用に識別idを付与

    commit("SET_CHANNEL_GROUP_STATUS_DATA", { targetChannelGroup: payload.channel_group, channel: statusDataWholeList });
  },









  /**
   * チャンネル一覧を取得.
   * 
   * localDBのキャッシュも考慮。API取得は searchChannelsDataFromApi() に依頼。
   */
  async getChannelsDetailDataList({ state, dispatch }, payload) {

    const channelTimeFrom = payload.channelTimeFrom ? payload.channelTimeFrom : state.channelTimeFrom;
    const channelTimeTo   = payload.channelTimeTo ? payload.channelTimeTo : state.channelTimeTo;

    const payloadForVersion = {
      vessel_id: payload.vessel_id,
      params : {
        origin: state.kind[payload.kind].originId,
        kind: payload.kind,
        datetime: channelTimeFrom,
      }
    }
    await dispatch("setVersionState", payloadForVersion).catch(error => {
      return Promise.reject(error)
    });
    const versionId = state.kind[payload.kind].versionId;

    let params = {
      channelTimeFrom: channelTimeFrom,
      channelTimeTo:   channelTimeTo,
      originId:        payload.origin_id,
      channelIds:      payload.channel_ids,
      vesselId:        payload.vessel_id,
      kind:            payload.kind,
      versionId:       versionId,  
    };


    // 既に保存してある customChannelIds か channelGroupData を使って、 channelInfoを作成
    // channelInfoが確定するとHighChartsPointList(拡張)が作れるので、コンバートしてセット

    let channelsDataList = new Array();
    // MasterData作成
    if (payload.channel_group == "custom") {
      _.forEach(payload.channel_ids, async (channel) => { // カスタムチャート
        let kind = channel.kind
        let obj = {
          channel_id: channel.id,
          channel_name: state.channelMaster[kind][channel.id].channel_name,
          display_unit: state.channelMaster[kind][channel.id].unit,
          kind: kind,
          order: channel.order,
          data: [],
          pointDataListQueryParams: params,
          hasError: false,
          value_number_range: state.channelMaster[kind][channel.id].value_number_range,
          value_string_options: state.channelMaster[kind][channel.id].value_string_options,
        }
        channelsDataList.push(obj)
      })
    } else {
      let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == state.selectedCategory })
      _.forEach(state.channelGroupData[index].channels, async function(channel, channel_id) { // 一般種別チャート
        let obj = {
          channel_id: channel_id,
          channel_name: channel.channel_name,
          display_unit: channel.unit,
          kind: channel.kind,
          hasError: false,
          data: [],
          pointDataListQueryParams: params,
          value_number_range: channel.value_number_range,
          value_string_options: channel.value_string_options,
        }
        channelsDataList.push(obj)
      })
    }

    if (payload.channel_group != "custom") {
      // カスタムレポート以外ならソートする

      channelsDataList.sort((a, b) => {
        // チャンネルIDの辞書順でソート。(仮)
        let comparison = 0;
        if (a.channel_id > b.channel_id) {
          comparison = 1;
        } else if (a.channel_id < b.channel_id) {
          comparison = -1;
        }
        return comparison ;
      })
    }

    return channelsDataList;
  },


  /**
   *  複数のchannel_idを指定して座標データ群を取得、出力はHighChartsにセット可能なデータ群。API通信は１回目だけ、２回目からはキャッシュを使う.
   * 
   */
  async convertChannelDataListForChart({ state, dispatch }, payload) {

    let channelIdsFromApi = [];

    // チャンネルデータ+座標データfromキャッシュのリストを作成して軸を固める。
    const cacheStartTime = moment().valueOf();
    const promiseChannelDataInfoList = payload.channelDataBlock.map( channelData => {
      return new Promise(async (resolve) => {

        let cachePointDataList = [];
        let channelDataFromCache = await SecureDataflowService.getChannelData(channelData.channel_id);
        if ( channelDataFromCache && channelDataFromCache.point_data) {
          const channelTimeFromValueOf = moment.utc(state.channelTimeFrom).valueOf();
          const channelTimeToValueOf   = ( payload.mode === "live" ) ? moment().valueOf() : moment.utc(state.channelTimeTo).valueOf();
          cachePointDataList = channelDataFromCache.point_data
                            .filter(pointData => ( moment( pointData.channel_time || pointData.timestamp ).valueOf() >= channelTimeFromValueOf
                                                && moment( pointData.channel_time || pointData.timestamp ).valueOf() <= channelTimeToValueOf));
        }
    
        // for debug
        if ( cachePointDataList.length < 60 ) {
          // キャッシュが利用できなかったchannel_idは記憶しておく。
          channelIdsFromApi.push(channelData.channel_id);
        }

        resolve({
                  channelId:     channelData.channel_id, 
                  channelData:   channelData,
                  pointDataList: cachePointDataList,
                });  
      });  
    });
    let channelDataInfoList = await Promise.all(promiseChannelDataInfoList);
    if ( (moment().valueOf() - cacheStartTime) > 3000 ) {
      Vue.$log.debug("measure from Cache convertChannelDataListForChart channel_ids = ", payload.channelDataBlock.map(x => x.channel_id), ', time = ', moment().valueOf() - cacheStartTime, 'ms ', moment(cacheStartTime).format('HH:mm:ss') );
    }


    // キャッシュ利用できなかったチャンネルはAPIで一括取得
    let pointDataListMapFromApi = {};
    if ( channelIdsFromApi.length > 0 ) {
      const apiStartTime = moment().valueOf();

      const params = payload.channelDataBlock[0].pointDataListQueryParams;
      //const channelTimeTo = ( payload.mode === "live" ) ? moment().toISOString() : params.channelTimeTo;
      let channelTimeFrom = null
      let channelTimeTo = null
      if (payload.mode === "live") {
        // ズームされた状態でもズーム前の時間幅でデータを取得
        const maxLiveTimeRange = state.liveDataTimeRangeOptions[0]
        channelTimeFrom = moment().subtract(maxLiveTimeRange, 'minutes').toISOString()
        channelTimeTo = moment().toISOString()
      } else {
        channelTimeFrom = state.xZoomStoredRange ? state.xZoomStoredRange[0].from : params.channelTimeFrom
        channelTimeTo = state.xZoomStoredRange ? state.xZoomStoredRange[0].to : channelTimeTo
      }
      const payloadForSearchChannels = {
        vessel_id: params.vesselId,
        params: {
          origin:            params.originId,
          kind:              params.kind,
          version_id:        params.versionId,
          channel_time_from: channelTimeFrom,
          channel_time_to:   channelTimeTo,
          channel_ids:       channelIdsFromApi,
        }
      };
      const resData = await dispatch("searchChannelsDataFromApi", payloadForSearchChannels).catch(error => {
        return Promise.reject(error)
      }); // API通信実行.

      resData.data && resData.data.forEach( channelData => {
        pointDataListMapFromApi[channelData.channel_id] = channelData.channel_data;
      });

      if ( (moment().valueOf() - apiStartTime) > 3000 ) {
        Vue.$log.debug("measure from API   convertChannelDataListForChart channel_ids = ", channelIdsFromApi, ', time = ', moment().valueOf() - apiStartTime, 'ms ', params.channelTimeFrom, params.channelTimeTo, moment(apiStartTime).format('HH:mm:ss') );
      }
    }

  
    // チャンネルデータ +（ 座標データ群fromキャッシュ or 座標データ群fromAPI ) を HighCharts用に加工 
    const promisePointDataInfoList = channelDataInfoList.map( channelDataInfo => {
      return new Promise(async (resolve) => {

        // ポイント座標データ群を API取得結果とキャッシュのどちらから取得するかを決定.
        const pointDataList = pointDataListMapFromApi[channelDataInfo.channelId] 
                                ? pointDataListMapFromApi[channelDataInfo.channelId] 
                                : channelDataInfo.pointDataList;

        // ポイント座標データ群をチャート表示用に変換
        const convertedPointDataList = await dispatch( "convertPointDataList", {
                                        channel_id:           channelDataInfo.channelData.channel_id,
                                        value_number_range:   channelDataInfo.channelData.value_number_range,
                                        value_string_options: channelDataInfo.channelData.value_string_options,
                                        pointDataList: pointDataList,
                                      });

        // HighChartsに渡す前にポイント座標データの重複を除去.
        let distinctConvertedPointDataList = [];
        let prevConvertedPointDataX = 0;
        for(let convertedPointData of convertedPointDataList ){
          if ( prevConvertedPointDataX < convertedPointData.x ) {
            distinctConvertedPointDataList.push(convertedPointData);
          }
          prevConvertedPointDataX = convertedPointData.x;
        }

        resolve({
                  channelId:              channelDataInfo.channelId,
                  convertedPointDataList: distinctConvertedPointDataList,
                });
      });
    });

    return await Promise.all(promisePointDataInfoList);
  },


  /** 
   * 座標データ群をHighChart用に変換する。
   * 
   * channel_id           (from Master)
   * value_number_range   (from Master)
   * value_string_options (from Master)
   * pointDataList        (from ChannelDataDetail )
   * 
   */
  async convertPointDataList(_nouse, payload) {
    let pointDataList = payload.pointDataList;
    let value_number_range = payload.value_number_range;
    let stringOptions = payload.value_string_options ? payload.value_string_options.split("/") : [];

    let promiseAll = ! pointDataList ? [] : pointDataList.map(pointData => {
      return new Promise((resolve) => {

        let pointDataForHighCharts = {};
        if ( Object.keys(pointData).includes('vn') ) {
          // firestoreから来た場合
          const { timestamp, vn, vs, status } = pointData;
          let errorFlg = ChannelDataUtil.isAbnormalMachinery(status);
            pointDataForHighCharts = {
              x: timestamp,
              y: Math.round(vn * 1000000) / 1000000,
              y_string: vs,
              status: status,
              error: errorFlg,
              colorIndex: 10,
          };
        } else {
          // APIからの取得結果で、チャートのpointDataに使えそうなものは以下。
          const { channel_time, value_number, value_string, status } = pointData;
          let errorFlg = ChannelDataUtil.isAbnormalMachinery(status);

          pointDataForHighCharts = {
              x: moment(channel_time).valueOf(),
              y: Math.round(value_number * 1000000) / 1000000,
              y_string: value_string,
              status: status,
              error: errorFlg,
              colorIndex: 10,
          };
        }


        if (value_number_range) { // 数値データかイベントデータかの判断
          // normal
          pointDataForHighCharts.color = pointDataForHighCharts.error ? '#EB5757' : '#2D9CDB';
          pointDataForHighCharts.marker = {
            radius: 2,
            states: {
              hover: { 
                radius: 6,
              }
            }
          };  
        } else {
          // gantt
          const ganntPointIndex = stringOptions.findIndex(option => option === pointDataForHighCharts.y_string);
          if ( ganntPointIndex >= 0 ) {
            pointDataForHighCharts.y = ganntPointIndex;
            pointDataForHighCharts.color = pointDataForHighCharts.error ? "#9e4a50" : "#1F6D99";
            pointDataForHighCharts.marker= {
              radius: 6 ,
              symbol: stringOptions.length === 2 ? 'customRect2' : 'customRect3', // 独自定義のシンボルを指定.
              states: {
                hover: {
                  fillColor: pointDataForHighCharts.error ? '#eb5757' : '#2d9cdb', 
                  radius: 6,
                }
              }
            };
          } else {
            // y_stringが無効値の場合は、そのポイントデータはスキップ。
            pointDataForHighCharts = null; 
          }
        }

        resolve(pointDataForHighCharts);
      });
    });

    const expandPointDataList = await Promise.all(promiseAll);
    return expandPointDataList.filter(pointData => pointData != null);
  },


  /**
   * チャート座標情報をAPIから取得.
   * 
   */
  async searchChannelsDataFromApi(_, payload) {
    
    let res = await epVesselSdfChannel.searchChannelsData(payload.vessel_id, payload.params).catch(error => {
      return Promise.reject(error)
    });
    let promiseJob = [];
    res.data && res.data.data && res.data.data.forEach(e => {
        let job = new Promise((resolve) => {
          resolve(SecureDataflowService.saveChannelData(e.channel_id, e.channel_data));
        })
        promiseJob.push(job);
      }
    )
    
    return res.data
  },










  /**
   * アラートサマリ、イベントサマリに関する FireStoreの監視.
   */
  async subscribeChannelDataEngine({ state, commit, dispatch }) {
    const vessel = await SecureDataflowService.getVessel();
    const vesselId = vessel.vessel_info.id;
    let unsubscribeForAlert = await db
      .collection("vessel_channel_data")
      .doc("v_" + vesselId)
      .collection("aisea_alert")
      .doc(state.kind.aisea_alert.versionName)
      .collection("data")
      .onSnapshot(snapshot => {snapshot.docChanges().forEach(diff => {if (diff.type !== 'removed') {
          if ( diff.doc.data() ) {
            dispatch("appendLatestChannelDataForAlertAndEvent", {id: diff.doc.id, data: diff.doc.data(), kind: "aisea_alert"});
          }
        }});},
        function(error) {
          Vue.$log.error("Error at fireStore for aisea_alert. ", error);
        }
      );        
    commit("PUSH_UNSUBSCRIBE", unsubscribeForAlert);

    let unsubscribeForAlertEngine = await db
      .collection("vessel_channel_data")
      .doc("v_" + vesselId)
      .collection("engine")
      .doc(state.kind.engine.versionName)
      .collection("data")
      .onSnapshot(snapshot => {snapshot.docChanges().forEach(diff => {if (diff.type !== 'removed') {
          if ( diff.doc.data() ) {
            dispatch("appendLatestChannelDataForAlertAndEvent", {id: diff.doc.id, data: diff.doc.data(), kind: "engine"});
          }
        }});},
        function(error) {
          Vue.$log.error("Error at fireStore for aisea_alert. ", error);
        }
      );        
    commit("PUSH_UNSUBSCRIBE", unsubscribeForAlertEngine);
  },


  /**
   * 有効なアラートサマリ、イベントサマリをstateに保存する処理.
   */
  async appendLatestChannelDataForAlertAndEvent({ commit, state }, obj){
    let channelId = obj.id,
        docData = obj.data,
        kind = obj.kind;
    // statusにキーワードが含まれていて、timestampが新しければ、アラートサマリーstateの先頭へunshift。
    if ( docData.status && ChannelDataUtil.isAbnormalMachinery(docData.status) ){
      const alertSummaryLiveData = state.alertSummaryLiveDatas.find(x => x.channel_id === channelId);
      const existingTimestamp = !alertSummaryLiveData ? 0 :
                              alertSummaryLiveData.timestamp ? alertSummaryLiveData.timestamp :
                              alertSummaryLiveData.channel_time ? moment(alertSummaryLiveData.channel_time).valueOf() : -1;
      if ( existingTimestamp < docData.timestamp && moment(state.channelTimeFrom).valueOf() <= docData.timestamp ) {

        let alertData = {
          timestamp: docData.timestamp,
          channel_time: ChannelDataUtil.isEventStatus(docData.status) ? moment(docData.timestamp).local().format("YYYY/MM/DD HH:mm:ss") : null,
          channel_id: channelId,
          channel_name: state.channelMaster[kind][channelId] ? state.channelMaster[kind][channelId].channel_name : "",
          value_number: ( docData.vn || docData.vs ),
          value_string: "",
          kind: kind,
          unit: state.channelMaster[kind][channelId] ? state.channelMaster[kind][channelId].unit : "",
          status: docData.status,
        };
        commit("ADD_ALERT_SUMMARY_LIVE_DATAS", alertData);

        if (ChannelDataUtil.isEventStatus(alertData.status)) {
          commit("ADD_ALERT_OCCUR_TIME", alertData);
        }
      }
    }

    // statusにキーワードが含まれて、timestampが新しければ、イベントサマリーstateの先頭へunshift。
    if ( docData.status && ChannelDataUtil.isEventStatus(docData.status)){
      const eventSummaryLiveData = state.eventSummaryLiveDatas.find(x => x.channel_id === channelId);
      const existingTimestamp = !eventSummaryLiveData ? 0 :
                              eventSummaryLiveData.timestamp ? eventSummaryLiveData.timestamp :
                              eventSummaryLiveData.channel_time ? moment(eventSummaryLiveData.channel_time).valueOf() : -1;
      if ( existingTimestamp < docData.timestamp && moment(state.channelTimeFrom).unix() <= docData.timestamp ) {

        let eventData = {
          timestamp: docData.timestamp,
          channel_time: moment(docData.timestamp).local().format("YYYY/MM/DD HH:mm:ss"),
          channel_id: channelId,
          channel_name: state.channelMaster[kind][channelId] ? state.channelMaster[kind][channelId].channel_name : "",
          value_number: ( docData.vn || docData.vs ),
          value_string: "",
          value_string_options: state.channelMaster[kind][channelId] ? state.channelMaster[kind][channelId].value_string_options : [],
          kind: kind,
          unit: state.channelMaster[kind][channelId] ? state.channelMaster[kind][channelId].unit : "",
          status: docData.status,
        };
        commit("ADD_EVENT_SUMMARY_LIVE_DATAS", eventData);
      }
    }
  },



  /**
   *  アラート発生時間を登録
   */
  async addAlertOccurTime({commit}, alertData) {
    commit("ADD_ALERT_OCCUR_TIME", alertData);
  },

  /**
   *  アラート発生時間に取得不能表示を登録
   */
  async setNotFoundAlertOccurTime({commit}, alertData) {
    commit("SET_NOT_FOUND_ALERT_OCCUR_TIME", alertData);
  },

  /**
   *  アラート発生時間を全てリセット
   */
   async resetAlertOccurTime({commit}) {
    commit("RESET_ALERT_OCCUR_TIME");
  },



  /**
   *  カスタムレポートの追加チャンネルを検索
   */
  async searchChannels(_nouse, payload) {
    let res = await epVesselSdfChannel.searchChannels(payload.vessel_id, payload.params);
    let resultChannels = [];
    res.data.channels.forEach(channel => {
      let obj = {
        id: channel.channel_id,
        name: channel.channel_name,
        unit: channel.unit,
        id_name: channel.channel_id + channel.channel_name,
      };
      resultChannels.push(obj);
    })
    return resultChannels
  },


  async setCustomChannelIdsState({ commit }, ids) {
    SecureDataflowService.setCustomChannel(ids);
    commit("SET_CUSTOM_CHANNEL_IDS", ids);
  },

  async setChannelGroupFocusPoint({ commit }, data) {
    commit("SET_CHANNEL_GROUP_FOCUS_POINT_MAP", data);
  },

  async setReferencedChannelIdMap({ commit }, data) {
    commit("SET_REFERENCED_CHANNEL_ID_MAP", data);
  },

  async changeCustomChartOrder({ dispatch }, data) {
    let customChannels = await SecureDataflowService.getCustomChannel();
    customChannels = customChannels.sort(function(a,b) {
      if (a.order < b.order) return -1
      if (a.order > b.order) return 1
      return 0
    })
    customChannels = customChannels.map((element, index) => {
      return {
        id: element.id,
        kind: element.kind,
        order: index
      }
    })
    let targetChannelIndex = customChannels.findIndex(channel => channel.id == data.channelId)
    if (targetChannelIndex > 0 && data.direction == "up") {
      customChannels[targetChannelIndex].order = targetChannelIndex - 1
      customChannels[targetChannelIndex - 1].order = targetChannelIndex
    }
    if (targetChannelIndex < customChannels.length - 1 && data.direction == "down") {
      customChannels[targetChannelIndex].order = targetChannelIndex + 1
      customChannels[targetChannelIndex + 1].order = targetChannelIndex
    }
    dispatch("setCustomChannelIdsState", customChannels)
  },

  async downloadCsv(_nouse, payload) {
    let res = await epVesselSdfChannel.downloadCsv(payload.vessel_id, payload.body);
    return res;
  },

  async download3dCsv(_nouse, payload) {
    let res = await epVesselSdfChannel.download3dCsv(payload.vessel_id, payload.body);
    return res;
  },

  async downloadCsvByStatus(_nouse, payload) {
    let res = await epVesselSdfChannel.downloadCsvByStatus(payload.vessel_id, payload.body);
    return res;
  },

  
  /**
   * FireStoreの監視解除.
   */
  async unsubscribeFirestore({ commit }) {
    commit("UNSUBSCRIBE_FIRE_STORE");
  },
  
  /**
   * FireStoreの監視追加(チャート専用).
   */
  async pushUnsubscribeForChart({ commit }, data) {
    commit("PUSH_UNSUBSCRIBE_FOR_CHART", data);
  },

  /**
   * FireStoreの監視解除(チャート専用).
   */
  async unsubscribeFirestoreForChart({ commit }) {
    await commit("UNSUBSCRIBE_FIRE_STORE_FOR_CHART");
  },

  /**
   * X軸ズーム状態管理
   */
  async addZoomCount({ commit }) {
    await commit("ADD_X_ZOOM_COUNT");
  },
  async reduceZoomCount({ commit }) {
    await commit("REDUCE_X_ZOOM_COUNT");
  },
  async resetZoomCount({ commit }) {
    await commit("RESET_X_ZOOM_COUNT");
  },

  /**
   * X軸ズーム状態管理(ライブモード)
   */
  async zoomInLiveChannelTime({ commit }) {
    await commit("ZOOM_IN_LIVE_CHANNEL_TIME")
  },
  async zoomOutLiveChannelTime({ commit }) {
    await commit("ZOOM_OUT_LIVE_CHANNEL_TIME")
  },
  async resetLiveChannelTime({ commit }) {
    await commit("RESET_LIVE_CHANNEL_TIME")
  },


  async setZoomStoredRange({ commit, state }) {
    let time_gap = moment(state.channelTimeTo).valueOf() - moment(state.channelTimeFrom).valueOf() // fromとtoの差を割り出す
    let xZoomRanges = []
    for (let index = 0; index < 4; index++) {
      let adjusted_time_gap = time_gap / 1000 * ((state.xZoomPercentage * index) / 100 / 2 )// ズーム後の時間幅計算
      let start_time = moment(state.channelTimeFrom).add(adjusted_time_gap, "s").format("HH:mm:ss")
      let end_time = moment(state.channelTimeTo).subtract(adjusted_time_gap, "s").format("HH:mm:ss")
      let time_from = moment(state.channelTimeFrom).format("YYYY-MM-DD") + "T" + start_time + ".000";
      let time_to   = moment(state.channelTimeTo).format("YYYY-MM-DD") + "T" + end_time   + ".000";
      let range = {
        from: moment(time_from).toISOString(),
        to: moment(time_to).toISOString()
      }
      xZoomRanges.push(range)
    }
    await commit("SET_X_ZOOM_STORED_RANGE", xZoomRanges)
  },

  async resetZoomStoredRange({ commit }) {
    await commit("SET_X_ZOOM_STORED_RANGE", null)
  },

  async setLiveDataTimeRange({ commit }, data) {
    await commit("SET_LIVE_DATA_TIME_RANGE", data)
  }
}